import { useState, useRef, useEffect } from 'react'

const useFakeProgress = (): [progress: number, start: () => void, end: () => void] => {
  const [progress, setProgress] = useState(0)
  const [started, setStarted] = useState(false)
  const timerIdRef = useRef<NodeJS.Timer>(undefined)

  const start = () => {
    if (!started) {
      setStarted(true)
    }
  }

  const end = () => {
    setStarted(false)
    setProgress(100)
  }

  useEffect(() => {
    if (started) {
      timerIdRef.current = setInterval(() => {
        setProgress((prev) => Math.trunc(Math.min(prev + Math.random() * 4, 99)))
      }, 1000)
    } else {
      clearInterval(timerIdRef.current)
    }
  }, [started])

  return [progress, start, end]
}

export default useFakeProgress
